<template>
  <loading-modal />
</template>

<script>
import LoadingModal from "@/components/utils/LoadingModal";

export default {
  name: "NewInvoiceView",
  components: { LoadingModal },
  props: {
    type: {
      type: String,
      default: "invoice",
    },
  },
  created() {
    this.$store.dispatch("addInvoice", { type: this.type });
  },
};
</script>
